import React from 'react';
import PropTypes from 'prop-types';
import ArrowRight from '@deliveroo/icon-set/react/ArrowRight';
import BackgroundImage from '@deliveroo/consumer-component-library/components/BackgroundImage';
import P from '@deliveroo/consumer-component-library/components/P';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import Icon from '@deliveroo/consumer-component-library/components/Icon';

import styles from './styles.scss';

/**
 * A component to display a single cuisine card.
 */
export default function CuisineCard({ url, imageUrl, title, description, linkText }) {
  return (
    <div className={styles.card}>
      <a href={url} className={styles.cardLink}>
        <span className={styles.image}>
          <BackgroundImage src={imageUrl} />
        </span>

        <div className={styles.details}>
          <Heading level={3} size="x-small">
            {title}
          </Heading>
          <span className={styles.description}>
            <P color="grey" spacing="small 0 0 0">
              {description}
            </P>
          </span>
          <P adjacentVerticalSpacing="medium">
            <span className={styles.linkText}>
              {linkText}
              <Icon component={ArrowRight} size={18} spacing="0 0 0 x-small" />
            </span>
          </P>
        </div>
      </a>
    </div>
  );
}

CuisineCard.propTypes = {
  /**
   * URL for the cuisine page, which the card links to.
   */
  url: PropTypes.string.isRequired,
  /**
   * URL for the image to be displayed on the card.
   */
  imageUrl: PropTypes.string.isRequired,
  /**
   * Title of the cuisine.
   */
  title: PropTypes.string.isRequired,
  /**
   * Description of the cuisine.
   */
  description: PropTypes.string.isRequired,
  /**
   * Text for the link to the cuisine page.
   */
  linkText: PropTypes.string.isRequired,
};
